/**
 * Build a descriptive sidebar title for Learning Support / IEP conversations.
 * Format (Option 5): Grade 5 • Autism Spectrum Disorder • Jul 9, 2026
 */

const GRADE_QUESTION = "Grade";
const DESIGNATION_QUESTION = "What is the student's designation category?";
const IEP_DATE_QUESTION = "IEP Date";

function formatIepDateForTitle(dateStr) {
  if (!dateStr) return "";
  const trimmed = String(dateStr).trim();
  if (!trimmed) return "";

  const mdy = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (mdy) {
    const date = new Date(Number(mdy[3]), Number(mdy[1]) - 1, Number(mdy[2]));
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
  }

  const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) {
    const date = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
  }

  return trimmed;
}

function shortenDesignationLabel(label) {
  if (!label) return "";
  const trimmed = String(label).trim();
  const withoutCode = trimmed.replace(/^[A-Z]\s*[–-]\s*/i, "").trim();
  if (withoutCode.toLowerCase().startsWith("other:")) {
    return withoutCode.replace(/^other:\s*/i, "").trim() || "Other";
  }
  return withoutCode || trimmed;
}

function normalizeGradeLabel(grade) {
  if (!grade) return "";
  const trimmed = String(grade).trim();
  if (!trimmed) return "";
  if (/^grade\s/i.test(trimmed) || /^kindergarten$/i.test(trimmed)) return trimmed;
  if (trimmed === "K") return "Kindergarten";
  return `Grade ${trimmed}`;
}

/**
 * @param {Record<string, string>} [answers] - questionnaire answers keyed by question text
 * @returns {string}
 */
export function buildLearningSupportSidebarTitle(answers = {}) {
  const parts = [];

  const grade = normalizeGradeLabel(answers[GRADE_QUESTION]);
  if (grade) parts.push(grade);

  const designation = shortenDesignationLabel(answers[DESIGNATION_QUESTION]);
  if (designation) parts.push(designation);

  const iepDate = formatIepDateForTitle(answers[IEP_DATE_QUESTION]);
  if (iepDate) parts.push(iepDate);

  if (parts.length === 0) return "Learning Support";
  return parts.join(" • ");
}
